<template>
	<div class="autocomplete calc-flex-col">
		<input
			ref="searchInput"
			v-model.trim="search"
			type="text"
			@input="onChange"
			@keydown.down="onArrowDown"
			@keydown.up="onArrowUp"
			@keydown.esc="onEsc"
			@keydown.enter="onEnter"
		/>
		<ul v-show="isOpen" class="autocomplete__results">
			<li v-if="isLoading" class="autocomplete__loading">
				Loading results...
			</li>
			<li v-else-if="!results.length" class="autocomplete__noResults">
				Sorry, we could not find any matches!
			</li>
			<li
				v-for="(result, i) in results"
				v-else
				:key="i"
				:tabindex="i"
				class="autocomplete__result"
				:class="{ 'is-active': i === arrowCounter }"
				@click="setResult(result)"
			>
				{{ result }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: "SearchAutocomplete",
	props: {
		partNumber: {
			type: String,
			default: "",
		},
		productData: {
			type: Array,
			required: false,
			default: () => [],
		},
		isAsync: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			search: "",
			results: [],
			isLoading: false,
			noResults: false,
			isOpen: false,
			arrowCounter: -1,
		};
	},
	//emits: ["update:productData"],
	watch: {
		productData: function (newValue, oldValue) {
			// If we have product data
			if (newValue.length !== oldValue.length) {
				this.results = newValue;

				this.isLoading = false;
			}
		},
	},
	mounted() {
		document.addEventListener("click", this.handleClickOutside);
	},
	unmounted() {
		document.removeEventListener("click", this.handleClickOutside);
	},
	methods: {
		setResult(result) {
			this.$emit("setLoading", true);

			this.search = result;
			this.isOpen = false;

			this.$emit("report-part-number", this.search);
		},
		filterResults() {
			let productArr = [];

			// Loop through productData
			for (const products of Object.entries(this.productData)) {
				// Push all the partNumbers into an array
				productArr.push(products[1]["Part_Number"]);
			}

			// Filter our partNumbers that do not match the user's input
			this.results = productArr.filter((product) => {
				return (
					product.toLowerCase().indexOf(this.search.toLowerCase()) >
					-1
				);
			});

			// If there are no matching results, show a message
			if (this.results.length < 1) {
				this.noResults = true;
			}
		},
		handleClickOutside(event) {
			if (!this.$el.contains(event.target)) {
				this.arrowCounter = -1;
				this.isOpen = false;
			}
		},
		onChange() {
			this.$emit("update:productData", this.search);

			if (this.isAsync) {
				this.isLoading = true;
			} else {
				this.filterResults();
				this.isOpen = true;
				this.noResults = false;
			}
		},
		onEsc() {
			this.arrowCounter = -1;
			this.isOpen = false;
		},
		onArrowDown() {
			if (this.arrowCounter < this.results.length) {
				this.arrowCounter = this.arrowCounter + 1;
			}
		},
		onArrowUp() {
			if (this.arrowCounter > 0) {
				this.arrowCounter = this.arrowCounter - 1;
			}
		},
		onEnter() {
			if (typeof this.results[0] === "undefined") {
				console.error("Search result error " + this.search);
				return;
			}

			// If the user didn't use the navigation window to select the part number
			// set this.search to the closest match
			// otherwise, use the part number the user selected through the navigation window
			this.search =
				typeof this.results[this.arrowCounter] === "undefined"
					? this.results[0]
					: this.results[this.arrowCounter];

			this.setResult(this.search);
			this.isOpen = false;
			this.arrowCounter = -1;
		},
	},
};
</script>
